import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useWorkflowStores } from "@/composables/workflowStores";
import FrameComment from "./FrameComment.vue";
import FreehandComment from "./FreehandComment.vue";
import MarkdownComment from "./MarkdownComment.vue";
import TextComment from "./TextComment.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowComment',
    props: {
        comment: null,
        scale: null,
        rootOffset: null,
        readonly: { type: Boolean }
    },
    emits: ["pan-by"],
    setup(__props, { emit }) {
        const props = __props;
        const cssVariables = computed(() => ({
            "--position-left": `${props.comment.position[0]}px`,
            "--position-top": `${props.comment.position[1]}px`,
            "--width": `${props.comment.size[0]}px`,
            "--height": `${props.comment.size[1]}px`,
        }));
        const { commentStore } = useWorkflowStores();
        function onUpdateData(data) {
            commentStore.changeData(props.comment.id, data);
        }
        function onResize(size) {
            commentStore.changeSize(props.comment.id, size);
        }
        function onMove(position) {
            commentStore.changePosition(props.comment.id, position);
        }
        function onPan(position) {
            emit("pan-by", position);
        }
        function onRemove() {
            commentStore.deleteComment(props.comment.id);
        }
        function onSetColor(color) {
            commentStore.changeColor(props.comment.id, color);
        }
        return { __sfc: true, props, emit, cssVariables, commentStore, onUpdateData, onResize, onMove, onPan, onRemove, onSetColor, FrameComment, FreehandComment, MarkdownComment, TextComment };
    }
});
